type GetNestedValue<
  T,
  Path extends string,
> = Path extends `${infer Key}.${infer Rest}`
  ? Key extends keyof T
    ? GetNestedValue<T[Key], Rest>
    : undefined
  : Path extends keyof T
    ? T[Path]
    : undefined;

export function getNestedValue<T, Path extends string>(
  obj: T,
  key: Path,
): GetNestedValue<T, Path> {
  return key.split('.').reduce((acc, part) => {
    if (acc && typeof acc === 'object' && part in acc) {
      // @ts-expect-error It's safe to access the property here
      return acc[part];
    }
    return undefined;
  }, obj) as GetNestedValue<T, Path>;
}
